export function target() {
  return this.module === 'BackgroundText' && !this.data.buttons;
}

export function migrate() {
  this.data.buttons = [];

  if (this.data.secondaryButtonText || this.data.secondaryButtonUrl) {
    const {
      secondaryButtonUrl: buttonUrl,
      secondaryButtonText: buttonText,
      secondaryButtonOpenInNewTab: buttonOpenInNewTab,
    } = this.data;

    this.data.buttons.push({
      buttonUrl,
      buttonText,
      buttonOpenInNewTab,
    });
  }

  if (this.data.primaryButtonText || this.data.primaryButtonUrl) {
    const {
      primaryButtonUrl: buttonUrl,
      primaryButtonText: buttonText,
      primaryButtonOpenInNewTab: buttonOpenInNewTab,
    } = this.data;

    this.data.buttons.push({
      buttonUrl,
      buttonText,
      buttonOpenInNewTab,
      buttonFeatured: true,
    });
  }
}
